import * as React from "react";
const SvgIcGraphBarFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M23 22H17V2H23V22ZM9 22H15V8H9V22ZM1 22H7V14H1V22Z" fill="currentColor" /></svg>;
export default SvgIcGraphBarFilled;